import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ 
    name: 'progress-container',
    template: '#progress-container'
})
export default class ProgressContainer extends Vue {

    @Prop({})
    small: boolean;

}